import React from 'react';
import {
  AccordionDetails as MaterialAccordionDetails,
  AccordionDetailsProps as MaterialAccordionDetailsProps,
} from '@mui/material';

interface AccordionDetailsProps extends MaterialAccordionDetailsProps {}

export const AccordionDetails = ({ ...rest }: AccordionDetailsProps) => (
  <MaterialAccordionDetails {...rest} />
);
